import PropTypes from 'prop-types'
import classNames from 'classnames'

import Button from '../button'
import Typography from '../typography'
import Card from './index'
import Icon from '../icon'
import DownloadFullColorIcon from '../icon/download-full-color.svg'
import Download from '../../bantrab/icon/download.svg'
import TagName from '../tagName'

import styles from '../../../styles/bantrab/components/card.module.scss'

const RecursoMediun = ({
  banner, title, minutes, textContent, date, sales, read, backgroundImage, file,
  categoryIcon, url, backgroundColor, backgroundIconColor, ...attrs
}) => {
  const { className } = attrs
  attrs.className = classNames(className, {
    [styles.card]: true
  })

  return (
    <div {...attrs}>
      <TagName url={url}>
        <Card.Media
          className={classNames([
            'rounded-border',
            'flex',
            'flex-row',
            backgroundColor
          ])}
          backgroundIconColor={backgroundIconColor}
          widgetLeft={
            <Icon
              width='100'
              height='100'
              className={'mt-6 ml-6'}
              svg={categoryIcon || DownloadFullColorIcon}
            />
          }
          widgetRight={
            <Typography
              tag={'h3'}
              weight={'black'}
              size={'five'}
              className={'m-6'}
              clamp={3}
              style={{ maxHeight: '6rem' }}>
              {banner}
            </Typography>
          }
        />
        <div className='flex flex-row justify-between items-center mt-4 mb-4'>
          <Typography tag={'span'} size={'three'} weight={'medium'} className={'text-green-500'}>
            {sales}
          </Typography>

          <Typography tag={'span'} size={'two'} weight={'regular'} className={'text-gray-400'}>
            {date}
          </Typography>
        </div>
        <Typography clamp={2} tag={'h3'} size={'four'} weight={'bold'} className={'mb-2'} style={{ minHeight: '3.5rem' }}>
          {title}1
        </Typography>

      </TagName>
      <Button
        className={'w-full mt-4'}
        background
        href={file}
      >
        Descargar
        <Icon className={'ml-2'} size={24} svg={Download} />
      </Button>

    </div>// end div principal
  )
}

RecursoMediun.propTypes = {
  banner: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
  title: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
  date: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
  minutes: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
  sales: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
  read: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
  textContent: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
  backgroundImage: PropTypes.any,
  file: PropTypes.any,
  categoryIcon: PropTypes.any,
  url: PropTypes.string,
  backgroundColor: PropTypes.string,
  backgroundIconColor: PropTypes.string
}

export default RecursoMediun
